import React, { Component } from 'react';

class Callout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDetails: false
      , isError: false
      , title: ''
      , message: ''
      , type: ''
      , icon: ''
      , details: {}
    };
    this.hide = this.hide.bind(this);
    this.show = this.show.bind(this);
    this.toggleDetails = this.toggleDetails.bind(this);
  }

  componentDidMount() {
    this.show(this.props.data);
  }

  hide() {
    this.props.onHide(this.props.data);
  }

  show(restResponse) {
    let title = 'Ops! Ocorreu um imprevisto!';
    let type = 'danger';
    let icon = 'ban';
    let isError = false;
    if (restResponse.status >= 200 && restResponse.status < 300) {
      title = restResponse.message;
      type = 'success';
      icon = 'check';
    } else if (restResponse.status === 404) {
      title = 'Dados não encontrados!';
      type = 'warning';
      icon = 'warning';
    } else {
      isError = true;
    }
    this.setState({
      isError: isError
      , title: title
      , type: type
      , icon: icon
      , message: restResponse.message
      , details: restResponse.data
    }, this.props.onShow);
  }

  toggleDetails() {
    this.setState({ showDetails: !this.state.showDetails });
  }

  renderdetails() {
    if (this.state.isError) {
      return (
        <div>
          <div className="row">
            <div className="col-md-12">
              <button type="button" className={'pull-right btn btn-xs btn-' + (this.state.type || 'danger')} onClick={this.toggleDetails}>
                <i className={'icon fa fa-' + (this.state.showDetails ? 'minus' : 'plus')}></i> Detalhes
              </button>
            </div>
          </div>
          {this.state.showDetails &&
            <div className="row">
              <div className="col-md-12">
                <hr />
                <pre className="callout-stacktrace">{JSON.stringify(this.state.details, null, 2)}</pre>
              </div>
            </div>
          }
        </div>
      );
    }
  }

  render() {
    return (
      <div className={'callout callout-' + (this.state.type || 'danger')}>
        <button type="button" className="close" onClick={this.hide}>×</button>
        <h4><i className={'icon fa fa-' + (this.state.icon || 'ban')}></i> {this.state.title}</h4>
        <div className="row">
          <div className="col-md-12">
            {this.state.message}
          </div>
        </div>
        {this.renderdetails()}
      </div>
    );
  }
}

export default Callout;


// WEBPACK FOOTER //
// ./src/modulos/componentes/Callout.js